import React, { useState } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  MenuItem,
  IconButton,
  InputAdornment,
  Snackbar,
  Alert,
} from "@mui/material";
import PasswordField from "../components/PasswordField";
import TopNavBar from "../components/TopNavBar";
import RefreshIcon from "@mui/icons-material/Refresh";
import { apiFetch } from "../api/apiClient";

export default function AccountPage() {
  const email = sessionStorage.getItem("email");
  const role = sessionStorage.getItem("role");
  const storedUserName = sessionStorage.getItem("username");
  const [username, setUsername] = useState(storedUserName);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleUpdateAccount = async (e) => {
    e.preventDefault();
    setError(null);
  };

  return (
    <>
      <TopNavBar heading={"Register New User"} />
      <Container maxWidth="xs">
        <Box
          sx={{
            mt: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Account Page - under construction
          </Typography>
          <Box component="form" onSubmit={handleUpdateAccount} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              fullWidth
              label="Email"
              value={email}
              disabled
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <PasswordField
                label="Enter Old Password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <PasswordField
                  label="New Password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <PasswordField
                  label="Confirm New Password"
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
              </Box>
              <TextField
                margin="normal"
                fullWidth
                label="Role"
                value={role}
                disabled
              />
              {error && (
                <Typography color="error" variant="body2">
                  {error}
                </Typography>
              )}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "Save Changes"}
              </Button>
            </Box>
          </Box>
          <Snackbar
            open={success}
            autoHideDuration={4000}
            onClose={() => setSuccess(false)}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert severity="success" onClose={() => setSuccess(false)}>
              User registered successfully!
            </Alert>
          </Snackbar>
        </Box>
      </Container>
    </>
  );
}
